// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { isiOSWeb } from '../../../../../utils';

const styles = css`
  .smooth-scroll-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    height: 100%;
    position: relative;
    cursor: grab;
  }
  .move {
    cursor: grabbing;
  }
  .smooth-scroll-list-tile {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    -ms-overflow-style: none;
    height: 100%;
    position: relative;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.couponSelfHelp ? 'margin-left: 7px;' : 'margin-left: 0px;')}
    }
  }
  .smooth-scroll-list::-webkit-scrollbar {
    display: none;
  }
  .smooth-scroll-list-item {
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    height: 100%;
    min-width: 300px;
    width: 33%;
    margin-right: 0;
  }
  .smooth-scroll-list-item:last-child {
    ${(props) =>
      props.fromBagPage && isiOSWeb() ? 'margin-right: 30px;' : '  margin-right: 50px;'}
  }
  .navigation-tile-cont {
    cursor: pointer;
    vertical-align: top;
    white-space: normal;
    min-width: 28px;
    background-color: #b0b0b0;
    display: inline-block;
    margin: 4px;
    width: 28px;
    height: 2px;
    position: relative;
  }
  .navigation-tile-cont-active {
    background-color: #1a1a1a;
  }

  .overlay-scroll {
    position: absolute;
    top: -10px;
    right: -10px;
    bottom: -10px;
    left: -10px;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .smooth-scroll-list-item {
      ${(props) => props.fromBagPage && isiOSWeb() && 'min-width: 320px;'}
    }
  }
`;

export default styles;
